function initProductDescriptionTabs(root) {
  if (!root || root.dataset.cmProductDescriptionInit === 'true') return;

  const tabs = root.querySelectorAll('[data-cm-product-description-tab]');
  const panels = root.querySelectorAll('[data-cm-product-description-panel]');

  if (!tabs.length || !panels.length) return;

  root.dataset.cmProductDescriptionInit = 'true';

  function activateTab(tab) {
    const panelId = tab.getAttribute('aria-controls');

    tabs.forEach((button) => {
      const isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      if (panel.id === panelId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });

    tab.addEventListener('keydown', (event) => {
      const currentIndex = Array.from(tabs).indexOf(tab);
      let nextIndex = null;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      activateTab(tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });
}

function initProductDescriptionSections(container = document) {
  container.querySelectorAll('[data-cm-product-description]').forEach(initProductDescriptionTabs);
}

document.addEventListener('DOMContentLoaded', () => {
  initProductDescriptionSections();
});

document.addEventListener('shopify:section:load', (event) => {
  initProductDescriptionSections(event.target);
});
